import { Loader2 } from "lucide-react";

interface LoaderProps {
    message?: string;
    size?: "sm" | "md" | "lg";
    className?: string;
}

export function Loader({ message = "Loading...", size = "md", className = "" }: LoaderProps) {
    const sizeClasses = {
        sm: "w-4 h-4",
        md: "w-8 h-8",
        lg: "w-12 h-12",
    };

    return (
        <div className={`flex items-center justify-center ${className}`}>
            <Loader2 className={`${sizeClasses[size]} text-primary animate-spin`} />
            <span className="ml-3 text-on-surface-variant">{message}</span>
        </div>
    );
}
